module.exports = __webpack_public_path__ + "img/document2.51de8a51.png";